@if (!hideAddButton()) {
  <mp-relation-list-item [addItem]="true" (click)="add.emit()">
    <mat-icon>add</mat-icon>
  </mp-relation-list-item>
}

<ng-content />
